import { max, min } from 'date-fns';
import { dateRanges } from "./dateRanges";

export const initialRanges = (t, minDate, maxDate) => [
  {
    id: 'TODAY',
    label: t('nameToday'),
    range: () => ({
      startDate: dateRanges.startOfToday,
      endDate: dateRanges.endOfToday,
    }),
  },
  {
    id: 'YESTERDAY',
    label: t('nameYesterday'),
    range: () => ({
      startDate: dateRanges.startOfYesterday,
      endDate: dateRanges.endOfYesterday,
    }),
  },
  {
    id: 'THIS_WEEK',
    label: t('nameThisWeek'),
    range: () => ({
      startDate: minDate ? max([dateRanges.startOfWeek, minDate]) : dateRanges.startOfWeek,
      endDate: maxDate ? min([dateRanges.endOfWeek, maxDate]) : dateRanges.endOfWeek,
    }),
  },
  {
    id: 'LAST_WEEK',
    label: t('nameLastWeek'),
    range: () => ({
      startDate: minDate ? max([dateRanges.startOfLastWeek, minDate]) : dateRanges.startOfLastWeek,
      endDate: maxDate ? min([dateRanges.endOfLastWeek, maxDate]) : dateRanges.endOfLastWeek,
    }),
  },
  {
    id: 'THIS_MONTH',
    label: t('nameThisMonth'),
    range: () => ({
      startDate: minDate ? max([dateRanges.startOfMonth, minDate]) : dateRanges.startOfMonth,
      endDate: maxDate ? min([dateRanges.endOfMonth, maxDate]) : dateRanges.endOfMonth,
    }),
  },
  {
    id: 'LAST_MONTH',
    label: t('nameLastMonth'),
    range: () => ({
      startDate: minDate ? max([dateRanges.startOfLastMonth, minDate]) : dateRanges.startOfLastMonth,
      endDate: maxDate ? min([dateRanges.endOfLastMonth, maxDate]) : dateRanges.endOfLastMonth,
    }),
  },
];
